<h3 class="display-10">{{ 'store.invitation.verifyTitle' | translate }}</h3>

<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="form-group mb-4">
    <header class="header-input-filed ">{{ 'store.invitation.storeName' | translate }}</header>
    <input (focusout)="validateStoreName()" id="inputEmail" type="text" formControlName="name"
           [ngClass]="{ 'is-invalid': submitted && f.name.errors }" [placeholder]="'store.invitation.storeNamePlaceholder' | translate" required=""
           autofocus="" class="form-control form-control-with-validation">
    <div *ngIf="submitted && f.name.errors" class="invalid-feedback">
      <div *ngIf="f.name.errors.required">{{ 'store.invitation.storeNameRequired' | translate }}</div>
    </div>
    <div *ngIf="uniqStoreName" style="margin-inline-start: 5px;  font-size: 12px; color: red;">
      <div>{{ 'store.invitation.storeNameTaken' | translate }}</div>
    </div>
  </div>
  <div class="form-group mb-3">
    <div class="content  mb-1" role="main">
      <div class="row">
        <div class="col-sm header-input-filed">
          <header>{{ 'store.auth.password' | translate }}</header>
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="contain-show-div form-group form-group-with-validation">
        <label class="align-end" (click)="passActive = !passActive">
          {{ (passActive ? 'store.auth.show' : 'store.auth.hide') | translate }}
        </label>
        <input id="inputPassword"
               type="password"
               formControlName="password"
               [ngClass]="{ 'is-invalid': submitted && f.password.errors }"
               [placeholder]="'store.auth.password' | translate"
               [attr.type]="passActive ? 'password' : 'text'"
               required=""
               class="form-control form-control-with-validation">
        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
          <header *ngIf="f.password.errors.required">{{ 'store.auth.passwordRequired' | translate }}</header>
        </div>
        <div *ngIf="submitted && !f.password.errors.required &&  f.password.value.length < 8" class="invalid-feedback">
          <header *ngIf="submitted && !f.password.errors.required &&  f.password.value.length < 8">
            {{ 'store.auth.passwordTooShort' | translate }}
          </header>
        </div>
      </div>
    </div>
  </div>
  <button type="submit" class="btn btn-primary">{{ 'common.next' | translate }}</button>
</form>
